import styled from "@emotion/styled";

export const PageContainer = styled("article")`
    position: relative;
    margin: 0 auto;
    max-width: 100%;

    @media screen and (min-width: 1230px) {
        width: 1200px;
    }
`;

export const InfoContainer = styled("section")`
    max-width: 100%;
    margin-top: 2rem;

    @media screen and (min-width: 1005px) {
        padding-right: 1rem;
    }

    @media print {
        max-width: 100%;
    }
`;

export const ModalContainer = styled(InfoContainer)`
    max-width: 100%;
    padding: 0 10px;
`;
